import Link from 'next/link';
import styles from './TestEds.module.scss';

export const PluginSetup = () => {
    return (
        <div className={styles.container}>
            <div className={styles.panel}>
                <h1>Настройка КриптоПРО ЭЦП Browser Plug-In</h1>

                <p>
                    После установки{' '}
                    <strong>КриптоПро ЭЦП Browser Plug-In</strong>
                    (и{' '}
                    <Link href="/test_eds/#CryptoSetupInfo">
                        <a>{' соответствующих '}</a>
                    </Link>
                    расширений если Вы используете Chrome или Opera), Вам
                    необходимо добавить нашу площадку в список доверенных узлов.
                </p>

                <ol>
                    <li>
                        Для этого нажмите
                        <strong>Пуск → Все программы → КриптоПРО.</strong>
                        <br />
                        Откройте файл{' '}
                        <strong>Настройки ЭЦП Browser Plug-In</strong>
                        в браузере Internet Explorer.
                        <br />
                        Если он не установлен в системе как браузер по
                        умолчанию, кликните на файле правой кнопкой мыши и
                        выберите пункт
                        <strong>Открыть с помощью → Internet Explorer</strong>.
                        <img
                            src="/assets/dummy-data/instructions/open_with_ie.png"
                            alt="Откройте настройки ЭЦП Browser Plugin с помощью Internet Explorer"
                            title="Откройте настройки ЭЦП Browser Plugin с помощью Internet Explorer"
                        />
                    </li>
                    <li>
                        При открытии файла, Internet Explorer сообщит о
                        блокировке сценария. Разрешите{' '}
                        <strong>запуск заблокированного содержимого</strong>
                        (внешний вид и текст сообщения может варьироваться в
                        зависимости от версии ОС Windows и Internet Explorer).
                        <img
                            src="/assets/dummy-data/instructions/activex_notice.png"
                            alt="Сообщение о блокировке скрипта"
                            title="Сообщение о блокировке скрипта"
                        />
                        <img
                            src="/assets/dummy-data/instructions/activex_allowance.png"
                            alt="Разрешите заблокированное содержимое"
                            title="Разрешите заблокированное содержимое"
                        />
                        <img
                            src="/assets/dummy-data/instructions/accept_activex.png"
                            alt="Подтвердите разрешение на запуск заблокированного содержимого"
                            title="Подтвердите разрешение на запуск заблокированного содержимого"
                        />
                    </li>
                    <li>
                        Укажите адрес нашего сайта{' '}
                        <strong>http://estp.ru</strong>в списке доверенных узлов
                        и нажмите <strong>+</strong>.
                        <br />
                        Повторите это действие для адреса{' '}
                        <strong>https://estp.ru</strong>. После чего нажмите{' '}
                        <strong>Сохранить</strong>.
                        <img
                            src="/assets/dummy-data/instructions/enter_our_domain.png"
                            alt="Введите адрес нашего сайта в список доверенных узлов"
                            title="Введите адрес нашего сайта в список доверенных узлов"
                        />
                        <img
                            src="/assets/dummy-data/instructions/save_our_domain.png"
                            alt="Сохраните изменения"
                            title="Сохраните изменения"
                        />
                    </li>
                    <li>
                        Откройте
                        <strong>Сервис → Свойства браузера</strong>(
                        <strong>Tools → Internet Options</strong>) или
                        <br />
                        <strong>
                            Пуск (Start) → Панель управления (Control Panel) →
                            Режим отображения &ldquo;Мелкие значки&rdquo; →
                            Свойства браузера (обозревателя) (Internet Options).
                        </strong>
                        <br />
                        Перейдите на вкладку{' '}
                        <strong>Безопасность (Security)</strong>
                        выберите зону{' '}
                        <strong>Надежные сайты (Trusted Sites)</strong>
                        для настройки параметров безопасности
                        <br />и нажмите на <strong>Сайты (Sites)</strong>.
                        <img
                            src="/assets/dummy-data/instructions/open_trusted_sites.png"
                            alt="Откройте настройки доверенных сайтов"
                            title="Откройте настройки доверенных сайтов"
                        />
                    </li>
                    <li>
                        В открывшемся окне в области
                        <strong>
                            Добавить в зону следующий узел (Add this website to
                            the zone)
                        </strong>
                        укажите <strong>https://*.estp.ru</strong> и нажмите
                        кнопку
                        <strong>Добавить</strong>. Повторите действие для
                        адреса: <strong>http://*.estp.ru</strong>
                        <img
                            src="/assets/dummy-data/instructions/add_domain.png"
                            alt="Добавьте адрес нашего сайта в список узлов в зоне"
                            title="Добавьте адрес нашего сайта в список узлов в зоне"
                        />
                    </li>
                    <li>
                        Если Вы используете браузер Firefox,
                        <Link href="/test_eds">
                            <a>{' перейдите на страницу проверки ЭП '}</a>
                        </Link>
                        и после нажатия на значок рядом с адресом сайта в панели
                        навигации разрешите запуск установленного плагина нажав{' '}
                        <strong>Разрешить и запомнить.</strong>
                        Для Firefox (начиная с 52 версии), Chrome и Opera
                        необходимо установить расширения, указанные
                        <Link href="/test_eds">
                            <a title="Ссылки на плагины для Chrome и Opera">
                                {' здесь '}
                            </a>
                        </Link>
                        . В Internet Explorer подобных действий производить не
                        требуется.
                        <img
                            src="/assets/dummy-data/instructions/plugin-enable.png"
                            alt="Разрешите запуск плагина"
                            title="Разрешите запуск плагина в Firefox"
                        />
                    </li>
                </ol>
            </div>
        </div>
    );
};
